"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectAddress = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _selectors = require("../../redux/selectors");
var _devices = require("../../redux/actions/devices");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @todo remove translation key numbers */
/** @todo set default active building from redux */
/** @todo remove theme key from Redux after throwing theme to core wrapper */
const SelectAddress = () => {
  const [options, setOptions] = (0, _react.useState)([]);
  const dispatch = (0, _reactRedux.useDispatch)();
  const activeBuilding = (0, _reactRedux.useSelector)(_selectors.selectActiveBuilding);
  const buildings = (0, _reactRedux.useSelector)(_selectors.selectBuildings);
  const {
    9: tBuildings
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations) || {};
  const tV = (0, _paulCorePackage.useTranslationValue)();
  const theme = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getTheme);
  const updateSelector = (0, _react.useCallback)((_, value) => {
    dispatch((0, _devices.setActiveBuilding)(value));
  }, [dispatch]);
  (0, _react.useEffect)(() => {
    if (options.length && !activeBuilding) {
      dispatch((0, _devices.setActiveBuilding)(options[0].value));
    }
  }, [activeBuilding, options, dispatch]);
  (0, _react.useEffect)(() => {
    if (buildings) {
      const newBuildings = buildings.map((group, index) => {
        var _group$3, _group$4, _group$5;
        if (group.length > 1) {
          var _group$, _group$2;
          return {
            value: ((_group$ = group[0]) === null || _group$ === void 0 ? void 0 : _group$.id) || index,
            label: "".concat(tV((_group$2 = group[0]) === null || _group$2 === void 0 ? void 0 : _group$2.thingBuildingStreet), " ").concat(group.map(building => " ".concat(tV(building.thingBuildingHouseNumber))))
          };
        }
        return {
          value: ((_group$3 = group[0]) === null || _group$3 === void 0 ? void 0 : _group$3.id) || index,
          label: "".concat(tV((_group$4 = group[0]) === null || _group$4 === void 0 ? void 0 : _group$4.thingBuildingStreet), " ").concat(tV((_group$5 = group[0]) === null || _group$5 === void 0 ? void 0 : _group$5.thingBuildingHouseNumber))
        };
      });
      setOptions(newBuildings);
    }
  }, [buildings, tV]);
  if (options.length <= 1) return null;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      transition: 'all 0.2s ease',
      width: '364px',
      marginBottom: '40px',
      '& > div': {
        width: '100%'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_paulCorePackage.Select, {
    value: activeBuilding,
    updateSelector: updateSelector,
    item: {
      defaultValue: tBuildings,
      type: 'select'
    },
    theme: theme,
    options: options,
    variant: "secondary"
  }));
};
exports.SelectAddress = SelectAddress;